import { type DerivedEventLegacy, DerivedEventTypeLegacy } from '@verantos-dev/types-cohorts';

import { transformDerivedEventTypeToGrammarValue } from '../adapters/transformDerivedEventTypeToGrammarValue';

export const getNextDerivedEventsForDerivedEventNameChange = (
  derivedEvents: DerivedEventLegacy[],
  referencedEventName: string,
  newReferencedEventName: string,
  newType: DerivedEventTypeLegacy | undefined
) => {
  return derivedEvents.map((derivedEvent) => {
    const nextDerivedEventFilters = derivedEvent.eventFilters.map((eventFilter) => {
      const eventFilterReferenceEventName = eventFilter.eventName.value?.split('::')[1];
      if (
        eventFilterReferenceEventName?.slice(1, eventFilterReferenceEventName.length - 1) ===
        referencedEventName
      ) {
        return {
          ...eventFilter,
          eventName: {
            ...eventFilter.eventName,
            value: `${transformDerivedEventTypeToGrammarValue(
              newType
            )}::"${newReferencedEventName}"`,
          },
        };
      }

      return eventFilter;
    });

    return {
      ...derivedEvent,
      eventFilters: nextDerivedEventFilters,
    };
  });
};
